export default {
  title: 'Não conformidades',
  title_serviceOrder: 'Não conformidades de atividades',
  title_formReply: 'Não conformidades de formulários',
  question: 'Pergunta',
  place: 'Local',
  status: 'Status',
  opened: 'Aberta',
  concluded: 'Concluida',
  instancesCount: 'Qtd. ocorrências',
  instances: '{{count}} ocorrências',
  lastTime: 'Última vez {{time}}',
  actionPlans: 'Planos de ação',
  automations: 'Automações',
  integrations: 'Integrações',
  moreOptions: 'Mais opções'
}
